module.exports = __webpack_public_path__ + "static/media/saved_marina_marker.dce1f927.svg";